/* eslint-disable import/no-cycle */
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { NonAuthRoutes} from "./url";
import { Footer, Navbar } from "./components";
import { Icon } from '@iconify/react';
const Home = React.lazy(() => import("./pages/Home"));
const Contact = React.lazy(() => import("./pages/Contact"));
const About = React.lazy(() => import("./pages/About"));
const Consultation = React.lazy(() => import("./pages/Services/Consultation"));
const CyberSecurity = React.lazy(() => import("./pages/Services/CyberSecurity"));
const GreenEnergy = React.lazy(() => import("./pages/Services/GreenEnergy"));
const OilAndGas = React.lazy(() => import("./pages/Services/OilAndGas"));
const Brochure= React.lazy(() => import("./pages/Brochure"));

function Routers() {
  return (
    <div>
      <Suspense
        fallback={
          <div className="flex items-center justify-center mt-60 z-50">
            {/*<LoadingIcon className="suspense-loading-icon" />*/}
            <Icon icon="svg-spinners:bars-rotate-fade" />      
                </div>
        }
      >
        <Navbar/>
        <Routes>
          <Route path={NonAuthRoutes.Home} element={<Home />} />
          <Route path={NonAuthRoutes.Contact} element={<Contact/>} />
          <Route path={NonAuthRoutes.About} element={<About/>} />
          <Route path={NonAuthRoutes.Consultation} element={<Consultation/>} />
          <Route path={NonAuthRoutes.CyberSecurity} element={<CyberSecurity/>} />
          <Route path={NonAuthRoutes.GreenEnergy} element={<GreenEnergy/>} />
          <Route path={NonAuthRoutes.OilAndGas} element={<OilAndGas/>} />
          <Route path={NonAuthRoutes.Brochure} element={<Brochure/>} />

        </Routes>
        <Footer/>
      </Suspense>
    </div>
  );
}

export default Routers;
